// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.required-mark[data-v-578e8556] {\n  color: red;\n}\n.expected-note[data-v-578e8556] {\n  color: #707070;\n  font-size: 12px;\n}\n.full-width[data-v-578e8556] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
